import React, { FunctionComponent, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

// import {
//   Badge,
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  // Dt,
  Fab,
  IconButton,
  Page
} from '../../../components/v2/styled';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import { NutritionalValue } from '../../../models/NutritionalValue';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

// const { DateTime } = require("luxon");

type Props = {}

export const AdminFoodCalculationNutritionalValues: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("weight DESC, name ASC");
  const [search, setSearch] = useState<string>("");

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["admin", "nutritional_values", {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<NutritionalValue>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'nutritional_value',
          fields: ['id', 'name', 'has_maximum', 'measure', 'is_percentage_energy', 'is_grams_per_kilogram', 'is_client_enabled'],
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              is_admin: 1
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login?.id
  });







  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<NutritionalValue>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });








  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: t("coach.models.nutritional_values.name"), width: 250 },
    { field: 'measure', headerName: t("coach.models.nutritional_values.measure"), width: 250, renderCell: params => <>
      {!!params.row.measure && params.row.measure}{!!params.row.is_grams_per_kilogram && <>/kg</>} {!!params.row.is_percentage_energy && <>%EN</>}
    </> },
    { field: 'is_client_enabled', headerName: t("coach.models.nutritional_values.is_client_enabled"), width: 80, renderCell: params => <>
      {!!params.row.is_client_enabled && <Check color='primary' sx={{marginBottom: -0.75}} />}
      {!params.row.is_client_enabled && <Close color='secondary' sx={{marginBottom: -0.75}} />}
    </> },
  ];

  return <Page title={t("admin.menu.nutritional_values")}>
    <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
    />

    <DataGrid
      action_count={2}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="Edit" color="default" path={`/nutritional_value/${params.row.id}`}>
            <EditIcon />
          </IconButton>
          <IconButton title="Remove" destroyBtn color="default" onClick={() => {
            mutationDestroy.mutate({
              formData: {
                object: 'nutritional_value',
                id: params.row.id,
                ob: {
                  id: params.row.id,
                }
              }
            });
          }}>
            <DeleteIcon />
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />

    <Fab
      onClick={() => {
        navigate("/nutritional_value/new", {});
      }}
    />
  </Page>;
}
